export default "__VITE_PUBLIC_ASSET__8bbeb514__"